/**
 * Prompt types for MSAL login requests.
 * Shared between MsalHelper and MsalHelperV2.
 */ export var PromptType;
(function(PromptType) {
    /**
     * Login prompt shows the login screen where the user has to enter their username
     */ PromptType[PromptType["Login"] = 0] = "Login";
    /**
     * select_account gives the user a choice to select an account from a list of logged in accounts
     */ PromptType[PromptType["SelectAccount"] = 1] = "SelectAccount";
    /**
     * There is no UX prompt
     */ PromptType[PromptType["None"] = 2] = "None";
})(PromptType || (PromptType = {}));
